import { inject, Injectable } from "@angular/core";

import { Context, WINDOW } from "@hermes/core-app-core";

import { IDLE_CALLBACK_TIMEOUT_MS } from "../constants/analytics.constant";
import { AnalyticsEvent } from "../events/analytics.event";

/**
 * Send analytics event to google analytics.
 * The dataLayer is provided on window by the google tag manager script.
 */
@Injectable({
    providedIn: "root",
})
export class AnalyticsService {
    private context = inject(Context);
    private window = inject<Window & { dataLayer: unknown[] }>(WINDOW);

    /**
     * If it's in not SSR, format then send event to GTM
     * If more provider is needed, event must be send here
     *
     * @param event event to format and send to each provider
     */
    public sendData<T>(event: AnalyticsEvent<T>): void {
        if (this.context.isInBrowserMode()) {
            this.window.dataLayer = this.window.dataLayer ?? [];
            this.scheduleTask(() => {
                this.window.dataLayer.push(event.formatForGTM());
            });
        }
    }

    public sendRawData<T>(analytics: T): void {
        if (this.context.isInBrowserMode()) {
            this.window.dataLayer = this.window.dataLayer ?? [];
            this.scheduleTask(() => {
                this.window.dataLayer.push(analytics);
            });
        }
    }

    private scheduleTask(task: () => void): void {
        if ("requestIdleCallback" in this.window) {
            this.window.requestIdleCallback(task, {
                timeout: IDLE_CALLBACK_TIMEOUT_MS,
            });
        } else {
            setTimeout(task);
        }
    }
}
